import { Component, Input, OnInit } from '@angular/core';
import { DocumentModel } from '../../../model/DocumentModel';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css']
})
export class DocumentComponent implements OnInit {
  @Input()
  document: DocumentModel;
  color = "primary";

  constructor() { }

  updateCheckbox(e){

  }

  ngOnInit(): void {}
}
